import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 8C10.6587 8 9.57141 9.08731 9.57141 10.4286C9.57141 11.7698 10.6587 12.8571 12 12.8571C13.3412 12.8571 14.4286 11.7698 14.4286 10.4286C14.4286 9.08731 13.3412 8 12 8ZM7.57141 10.4286C7.57141 7.98274 9.55415 6 12 6C14.4458 6 16.4286 7.98274 16.4286 10.4286C16.4286 12.8744 14.4458 14.8571 12 14.8571C9.55415 14.8571 7.57141 12.8744 7.57141 10.4286Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 14.8571C9.71195 14.8571 7.85715 16.712 7.85715 19C7.85715 19.5523 7.40943 20 6.85715 20C6.30486 20 5.85715 19.5523 5.85715 19C5.85715 15.6074 8.60738 12.8571 12 12.8571C15.3926 12.8571 18.1429 15.6074 18.1429 19C18.1429 19.5523 17.6951 20 17.1429 20C16.5906 20 16.1429 19.5523 16.1429 19C16.1429 16.712 14.288 14.8571 12 14.8571Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
			fill: "currentColor"
		})
	]
});
export default SvgAccount;
